/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { FullVisitBucketViewModel } from './FullVisitBucketViewModel'; 

export function getFullVisitBucketOptions(bucketId: string, onSuccess?: (result: FullVisitBucketViewModel) => void) {
	return queryOptions({
		queryKey: ['full-visit-bucket', bucketId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/visits/queries/getvisitdata/getfullvisitbucket/' + bucketId;
			const resp = await axios.get<FullVisitBucketViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(bucketId)
	});
}